import PropTypes from 'prop-types';
import { CustomsContentValues } from '../enums/customs-content';
import { CustomsNonDelivery } from '../enums/customs-non-delivery';
import { CustomsItemPropType } from '../prop-types/customs-item';

export const customsPropTypesObject = {
  content: PropTypes.oneOf(CustomsContentValues.map((value) => value.name)),
  nonDelivery: PropTypes.oneOf(Object.values(CustomsNonDelivery).map((value) => value.name)),
  customsItems: PropTypes.arrayOf(CustomsItemPropType),
};

export const CustomsPropType = PropTypes.shape(customsPropTypesObject);

/**
 * @typedef CustomsPropType
 * @property {(
 *   'Merchandise'|
 *   'Documents'|
 *   'Gift'|
 *   'ReturnedGoods'|
 *   'Sample'
 * )} content
 * @property {('Return'|'Abandon')} nonDelivery
 */
